import React from "react";
import { cn } from "../lib/helpers";
import { responsiveTitle1, pageTitle } from "./typography.module.css";

import styles from "./team-members-grid.module.css";
import TextSection from "./text-section";
import TeamMemberCard from "./team-member-card";
import TextBrandCard from "./text-brand-card";
import ImageBrandCard from "./image-brand-card";
import LottieBrandCard from "./lottie-brand-card";

function TeamMembersGrid(props) {
  const { title, members, closingCopy } = props;

  return (
    <div className={cn(styles.root)}>
      <div className={styles.content}>
        {title && <h2 className={cn(responsiveTitle1, pageTitle, styles.title)}>{title}</h2>}
        <ul className={cn(styles.grid, members.length % 3 == 1 ? styles.centerLastItem : "")}>
          {members &&
            members
              .filter((node) => !node.disabled)
              .map((node, index) => {
                let el = null;
                switch (node._type) {
                  case "teamMember":
                    el = <TeamMemberCard {...node} />;
                    break;

                  case "textBrandCard":
                    el = <TextBrandCard {...node} isOnTeamPage={true} />;
                    break;

                  case "imageBrandCard":
                    el = <ImageBrandCard {...node} isOnTeamPage={true} />;
                    break;

                  case "lottieBrandCard":
                    el = <LottieBrandCard {...node} isOnTeamPage={true} />;
                    break;

                  default:
                    el = null;
                    break;
                }
                return <li key={index}>{el}</li>;
              })}
        </ul>
      </div>
      {closingCopy && (
        <div className={styles.text}>
          <TextSection bodyText={closingCopy} alignment="center" disablePadding={true} />
        </div>
      )}
    </div>
  );
}

export default TeamMembersGrid;
